import { render } from "./OTPVerification.vue?vue&type=template&id=d6c6ab72&scoped=true"
import script from "./OTPVerification.vue?vue&type=script&lang=js"
export * from "./OTPVerification.vue?vue&type=script&lang=js"

import "./OTPVerification.vue?vue&type=style&index=0&id=d6c6ab72&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6c6ab72"]])

export default __exports__